<!-- 多选老师 -->
<template>
  <el-form-item :label="label">
    <el-select v-model="teacherSelectedList" :multiple="config.multiple === false ? false : true" :placeholder="config.placeholder" :clearable="true"
      filterable :filter-method="getTeacherList" collapse-tags collapse-tags-tooltip @visible-change="loseFocus">
      <el-option v-for="item in teacherList" :label="item.name" :value="item.id" :key="item.id"></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { inject, onMounted, ref } from 'vue';

export default {
  kind: 'yq-老师多选',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: () => [],
    },
    config: {
      type: Object,
      default() {
        return {
          placeholder: '请选择',
          multiple: true,
        };
      },
    },
    label: {
      type: String,
      default: '老师：',
    },
  },
  setup(props) {
    const child = ref(null);
    const useQuery = inject('useQuery');
    const api = inject('api');

    const teacherList = ref([]);
    let teacherSelectedList = ref([]);

    async function getTeacherList(queStr) {
      const res = await api.allTeacherList({
        scene: 0,
        queryKey: queStr,
      });
      teacherList.value = res.data;
    }
    getTeacherList();

    function reset() {
      teacherSelectedList.value = props.value.map((v) => v.id);
    }

    teacherSelectedList = useQuery('teacherMulti', props.value, reset);

    if (props.value.length > 0) {
      onMounted(() => {
        teacherSelectedList.value = props.value.map((v) => v.id);
      });
    }

    return {
      child,
      teacherList,
      teacherSelectedList,
      getTeacherList,
      loseFocus(val) {
        // 下拉框隐藏时重新刷新一下老师列表，否则还是展示之前的搜索结果
        if (!val) {
          getTeacherList('');
        }
      },
    };
  },
};
</script>
